import { Spinner, Stack } from '@optimus-web/core';

export const Loader = (props: React.ComponentProps<typeof Spinner>) => (
    <Stack className="loader" itemAlignment="center" alignment="center">
        <Spinner {...props} />
    </Stack>
);
